<div class="outer">
  <div class="inner">
    <iframe width="100%" height="500" id="gmap_canvas"
      src="https://maps.google.com/maps?q=Barbershop%20Denim%20Philadelphia%20Pa&t=&z=15&ie=UTF8&iwloc=&output=embed"
      frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
    </iframe>
  </div>
</div>
